import {
    ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    SIGNAL_ANALYSIS_MANAGEMENT_PAGE_ROUTE,
} from "app/pages/sales-intelligence/constants/routes";

const SIGNALS_MANAGEMENT_BREADCRUMB = {
    state: ACCOUNT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    title: "si.account-signals.management.breadcrumbs.signals-management",
};

export const INTENT_SIGNALS_BREADCRUMBS = [
    SIGNALS_MANAGEMENT_BREADCRUMB,
    {
        state: INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
        title: "si.account-signals.management.breadcrumbs.intent-management",
    },
];

export const SIGNAL_ANALYSIS_BREADCRUMBS = [
    SIGNALS_MANAGEMENT_BREADCRUMB,
    {
        state: SIGNAL_ANALYSIS_MANAGEMENT_PAGE_ROUTE,
        title: "si.pages.signal-recommender.title",
    },
];
